import { ConfigState } from '../../../models';
import { CONFIG_MUTATIONS_KEYS } from '../config.const';
import { ConfigMutation } from '../config.interfaces';

export class SetCurrencyMutation implements ConfigMutation {
  mutations = {
    [CONFIG_MUTATIONS_KEYS.setCurrency]: (config: ConfigState, currencyCode: string) => {
      config.dynamic.currency = currencyCode;
    }
  };
}
